import { loadingTypes } from '@/constants/loadingTypes';

import { ApiBase } from './api-base';

/**
 * @template R
 * @typedef {import('axios').AxiosResponse<R>} AxiosResponse<R>
 */
/**
 * @typedef {import('@/models/estimate.interface').Estimate} Estimate
 */

export class EstimatesApi extends ApiBase {
  /**
   * @private
   * @readonly
   */
  ESTIMATES_API_ROOT = 'estimations';

  /**
   * Get single estimate by id
   * @param {string} id estimate id
   * @returns {Promise<AxiosResponse<Estimate>>}
   */
  getEstimate = (id) => this.apiClient.sendRequest({
    method: 'GET',
    url: `${this.ESTIMATES_API_ROOT}/${id}`,
  }, { loadingType: loadingTypes.syncEmployeeButton });

  /**
   * Get multiple employees by project id or office ids
   * @param {GetEmployeesParams} [params={}] project id or offices ids
   * @returns {Promise<AxiosResponse<Estimate[]>>}
   */
  getEstimations = ({ projectId } = {}) => this.apiClient.sendRequest({
    method: 'GET',
    url: `${this.ESTIMATES_API_ROOT}/`,
    params: {
      project_id: projectId,
    },
  }, { loadingType: loadingTypes.none });

  getEstimationsWithRoles = ({ projectId } = {}) => this.apiClient.sendRequest({
    method: 'GET',
    url: `${this.ESTIMATES_API_ROOT}/with-roles`,
    params: {
      project_id: projectId,
    },
  }, { loadingType: loadingTypes.none });

  addProjectEstimate = (estimate) => this.apiClient.sendRequest({
    method: 'POST',
    url: `${this.ESTIMATES_API_ROOT}/`,
    data: estimate,
  });

  deleteProjectEstimate = (estimateID) => this.apiClient.sendRequest({
    method: 'DELETE',
    url: `${this.ESTIMATES_API_ROOT}/${estimateID}`,
  });

  import = ({ projectId, file }) => this.apiClient.sendRequest({
    method: 'POST',
    url: `${this.ESTIMATES_API_ROOT}/import?project_id=${projectId}`,
    data: file,
  });

  changeProjectEstimate = (estimateID, estimate) => this.apiClient.sendRequest({
    method: 'PUT',
    url: `${this.ESTIMATES_API_ROOT}/${estimateID}`,
    data: estimate,
  }, { loadingType: loadingTypes.none });
}
